<script>
import api from '@/command/api'
import TemplateHeaderTable from '@/components/TemplateHeaderTable'
import apiTool from '@/command/apiTool'
import DrawerForm from '@/components/DrawerForm'
import { postAction, getAction } from '@/command/netTool'
import moment from 'moment'
import { partList } from '@/utils/textFile'
export default {
  name: 'employment',
  data() {
    return {
      ...api.command.getState(),
      storeData: [],
      dataId: null,
      specificationsDataList: [],
    }
  },
  mounted() {
    this.handleGetInit()
  },
  methods: {
    handleGetInit() {
      api.command.getList.call(this, {
        url: '/farmYsJob/page',
        current: 1,
      })
    },
    getHeader() {
      return [
        {
          name: '名称',
          type: 'input',
          key: 'positionName',
        },
        {
          name: '部门',
          key: 'part',
          type: 'select',
          typeData: partList,
        },
      ]
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'id',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'positionName',
          title: '职位名称',
          filter: true,
          align: 'left',
          sorter: (a, b) => a.positionName.length - b.positionName.length,
        },
        {
          dataIndex: 'part',
          title: '部门',
          align: 'left',
          customRender: (text) => {
            return (partList.find((e) => e.value == text) || { name: '' }).name
          },
          onExport: (text) => {
            return (partList.find((e) => e.value == text) || { name: '' }).name
          },
        },
        {
          dataIndex: 'recruitmentQuantity',
          title: '招聘数量',
          align: 'left',
        },
        {
          dataIndex: 'employedNum',
          title: '已入职',
          align: 'left',
        },
        {
          dataIndex: 'resumeTotal',
          title: '简历总数',
          align: 'left',
          sorter: (a, b) => a.resumeTotal - b.resumeTotal,
        },
        {
          dataIndex: 'upDown',
          title: '状态',
          type: 'badge',
          //   filters: [
          //     {
          //       text: '上架',
          //       value: '0'
          //     },
          //     {
          //       text: '下架',
          //       value: '1'
          //     }
          //   ],
          onExport: (records) => {
            return ['上架', '下架'][records]
          },
          filterMultiple: false,
          render(data) {
            return {
              showDot: true,
              name: data == 0 ? '上架' : '下架',
              color: data == 0 ? 'green' : 'red',
            }
          },
        },
        {
          dataIndex: 'a9',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          typeData: ({ records }) => {
            return [
              {
                name: records.upDown == 0 ? '下架' : '上架',
                onClick: () => {
                  api.command.edit.call(this, {
                    url: `/farmYsJob/${records.upDown == 0 ? 'down' : 'up'}`,
                    params: {
                      ids: [records.id],
                    },
                  })
                },
              },
              {
                name: '编辑',
                onClick: () => {
                  this.onRowSelect(records)
                },
              },
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认是否删除吗?',
                onClick: () => {
                  api.command.delDelArr.call(this, {
                    url: '/farmYsJob/delete',
                    params: {
                      ids: [records.id],
                    },
                  })
                },
              },
            ]
          },
        },
      ]
    },
    getButton() {
      return [
        {
          name: '添加',
          type: 'primary',
          icon: 'plus',
          onClick: () => {
            this.onRowSelect()
          },
        },
        {
          viewType: 'menu',
          name: '更多操作',
          isBatch: true,
          children: [
            {
              name: '批量删除',
              onClick: (data) => {
                let ids = data.map((e) => e.id)
                return api.command.delDelArr.call(this, {
                  url: '/farmYsJob/delete',
                  params: { ids },
                })
              },
            },
            {
              name: '批量上架',
              onClick: (data) => {
                let ids = data.map((e) => e.id)
                return api.command.edit.call(this, {
                  url: '/farmYsJob/up',
                  params: { ids },
                })
              },
            },
            {
              name: '批量下架',
              onClick: (data) => {
                let ids = data.map((e) => e.id)
                return api.command.edit.call(this, {
                  url: '/farmYsJob/down',
                  params: { ids },
                })
              },
            },
          ],
        },
      ]
    },
    getDrawerForm(source, formData) {
      const form = [
        {
          title: '基本信息',
          form: [
            {
              name: '职位名称',
              type: 'input',
              key: 'positionName',
              labelAlign: 'left',
            },
            {
              name: '部  门',
              type: 'select',
              key: 'part',
              typeData: partList,
              labelAlign: 'left',
            },
          ],
        },
        {
          title: '职位描述',
          form: [
            {
              name: '描述',
              type: 'textArea',
              key: 'remark',
              labelAlign: 'left',
            },
          ],
        },
      ]
      return form
    },
    onRowSelect(records = {}) {
      if (records.id) {
        this.dataId = records.id
        getAction('/api/farmYsJob/detail/' + records.id).then((result) => {
          if (result.code == 200) {
            this.handleStatePopup(result.data)
          } else {
            this.$message.error(result.msg)
          }
        })
      } else {
        this.dataId = null
        this.handleStatePopup()
      }
    },
    handleStatePopup(source = {}) {
      let that = this
      apiTool.showDrawer({
        title: '就业信息',
        width: '600px',
        view: DrawerForm,
        viewProps: {
          data: (formData) => that.getDrawerForm(source, formData),
          form: source,
          formProps: {
            layout: 'horizontal',
            cols: 24,
            labelCol: { span: 3 },
            wrapperCol: { span: 21 },
          },
        },
        success: ({ data, setHidden }) => {
          api.command[!that.dataId ? 'create' : 'editPost']
            .call(that, {
              url: `/farmYsJob/${!that.dataId ? 'add' : 'update'}`,
              params: {
                ...data,
                id: that.dataId,
              },
            })
            .then(setHidden)
        },
        foot: ({ close, submit }) => {
          return [
            {
              name: '取消',
              onClick: close,
            },
            {
              name: '保存',
              type: 'primary',
              onClick: submit,
            },
          ]
        },
      })
    },
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        button={this.getButton()}
        records={this.records}
      />
    )
  },
}
</script>
